import "jquery-smooth-scroll";
import "jquery.easing";
import { isMobile } from "./isMobile";

/*
 *
 * ----------------------------------------------- */
(function () {
  if (typeof $.smoothScroll !== "function") return;

  var reSmooth = /^#sm-/;

  $(window).on("load", function () {
    if (!reSmooth.test(location.hash)) return;

    var id = "#" + location.hash.replace(reSmooth, "");
    var offset = isMobile() ? -90 : -85;

    setTimeout(function () {
      $.smoothScroll({
        scrollTarget: id,
        offset: offset,
        easing: "easeInOutCubic",
        speed: 800,
        afterScroll: function () {
          var $t = $(id);
          if (!$t.length) return;

          var desired = $t.offset().top + offset;
          var current = $(window).scrollTop();

          if (Math.abs(desired - current) > 20) {
            $("html, body").stop(true).scrollTop(desired);
          }
        },
      });
    }, 50);
  });
})();

/*
 *
 * ----------------------------------------------- */
// jQuery Smooth Scroll - v2.2.0 - 2017-05-05
// https://github.com/kswedberg/jquery-smooth-scroll
jQuery(function ($) {
  $("[data-sm]").smoothScroll({
    // offset: isMobile() ? -90 : -85,
    // beforeScroll: function (e) {
    //   if (e && e.scrollTarget) {
    //     var scrollTarget = e.scrollTarget;
    //     if (
    //       scrollTarget === "#contract" ||
    //       scrollTarget === "#services" ||
    //       scrollTarget === "#optional-services"
    //     ) {
    //       e.offset = -80;
    //     } else if (
    //       scrollTarget.startsWith("#contract-") ||
    //       scrollTarget.startsWith("#services-") ||
    //       scrollTarget.startsWith("#optional-services-")
    //     ) {
    //       e.offset = -80;
    //     }
    //   }
    // },
  });
});

/*
 *
 * ----------------------------------------------- */
$("svg a[data-sm-svg]").on("click", function (event) {
  event.preventDefault();

  // Determine the offset based on whether the device is mobile or not
  var offset = isMobile() ? -90 : -85;

  // Get the target element's ID from the href attribute
  var targetId = $(this).attr("href");

  // Calculate the target position with the offset
  var targetPosition = $(targetId).offset().top + offset;

  // Animate the scroll to the target position
  $("html, body").animate({ scrollTop: targetPosition }, 1000); // Adjust the duration as needed
});
